export const DASHBOARD_MONTH_OPTIONS = [
  { value: "all", label: "All Months" },
  { value: "01", label: "January" },
  { value: "02", label: "February" },
  { value: "03", label: "March" },
  { value: "04", label: "April" },
  { value: "05", label: "May" },
  { value: "06", label: "June" },
  { value: "07", label: "July" },
  { value: "08", label: "August" },
  { value: "09", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" },
];

export const buildDashboardQueryParams = ({
  year = "all",
  month = "all",
  shipmentType = "all",
} = {}) => {
  const params = new URLSearchParams();

  if (year && year !== "all") {
    params.set("year", year);
  }

  if (year && year !== "all" && month && month !== "all") {
    params.set("month", month);
  }

  if (shipmentType && shipmentType !== "all") {
    params.set("shipment_type", shipmentType);
  }

  const query = params.toString();
  return query ? `?${query}` : "";
};

export const matchesDashboardDateFilter = (
  jobOrder,
  dateValue,
  selectedYear = "all",
  selectedMonth = "all"
) => {
  if (selectedYear === "all") {
    return true;
  }

  if (!dateValue) {
    return false;
  }

  const parsedDate = new Date(dateValue);
  if (Number.isNaN(parsedDate.getTime())) {
    return false;
  }

  const matchesYear = parsedDate.getUTCFullYear() === Number(selectedYear);

  const matchesMonth =
    selectedMonth === "all" ||
    parsedDate.getUTCMonth() + 1 === Number(selectedMonth);

  return matchesYear && matchesMonth;
};
